import { Response } from 'superagent'

export type SessionCookieErrorCode =
  'invalid_cookie' // 送信したセッションcookieが不正
  | 'not_found' // セッションがサーバー側に存在しない
export type UnknownErrorCode = 'unknown'

export interface SessionApiErrorResponseInterface {
  errorCode: SessionCookieErrorCode | UnknownErrorCode
  message: string
}

export class SessionApiErrorResponse implements SessionApiErrorResponseInterface {
  public static fromResponse(response: Response): SessionApiErrorResponse {
    const body = response.body

    return new SessionApiErrorResponse(
      body.error_code || 'unknown',
      body.message || ''
    )
  }

  public static fromString(message: string): SessionApiErrorResponse {
    return new SessionApiErrorResponse('unknown', message)
  }

  constructor(
    public readonly errorCode: SessionCookieErrorCode | UnknownErrorCode,
    public readonly message: string
  ) {}
}
